module.exports = __webpack_public_path__ + "static/media/ads.f7f6a756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ads.png
// module id = 623
// module chunks = 0